module.exports = __webpack_public_path__ + "img/图片8.0400e43e.png";